import { render } from "./InfoButton.vue?vue&type=template&id=5c8d795f&ts=true"
import script from "./InfoButton.vue?vue&type=script&lang=ts"
export * from "./InfoButton.vue?vue&type=script&lang=ts"

import "./InfoButton.vue?vue&type=style&index=0&id=5c8d795f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__